import { render, staticRenderFns } from "./UrlPlanning.vue?vue&type=template&id=0f77e27d&scoped=true"
import script from "./UrlPlanning.vue?vue&type=script&lang=js"
export * from "./UrlPlanning.vue?vue&type=script&lang=js"
import style0 from "./UrlPlanning.vue?vue&type=style&index=0&id=0f77e27d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f77e27d",
  null
  
)

export default component.exports